<template>
  <div class="intranet-penetration">
    <!-- 首屏 banner -->
    <div class="section-banner">
      <div class="banner-main">
        <div class="banner-left">
          <div class="banner-title move">内网穿透</div>
          <div class="banner-subtitle move delay-100"">将内网服务安全的发布到公网</div>
          <div class="banner-desc move delay-200">
            将内网的网页及服务，如个人站点、博客、NAS、OA、终端、数据库等。发布为可在互联网上安全访问的域名。
          </div>
          <div class="banner-btns">
            <div class="btn-primary" @click="goDownload">立即体验</div>
            <div class="btn-ghost" @click="goDoc">查看文档</div>
          </div>
        </div>
        <img class="banner-pic" :src="bannerNat" alt="" />
        <div class="banner-features">
          <div class="feature-item">
            <img class="feature-icon" :src="featFast" alt="" />
            <div class="feature-text">
              <div class="feature-title">快速发布</div>
              <div class="feature-sub">20秒快速上线</div>
            </div>
          </div>
          <div class="feature-item">
            <img class="feature-icon" :src="featSafe" alt="" />
            <div class="feature-text">
              <div class="feature-title">安全可控</div>
              <div class="feature-sub">多层安全规则</div>
            </div>
          </div>
          <div class="feature-item">
            <img class="feature-icon" :src="featStable" alt="" />
            <div class="feature-text">
              <div class="feature-title">稳定可靠</div>
              <div class="feature-sub">高可用架构，稳定在线</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 核心优势 -->
    <div class="section-adv">
      <div class="adv-main">
        <div class="section-title move">核心优势</div>
        <div class="section-sub move delay-100">轻松管理多节点网络</div>
        <div class="adv-grid">
          <div class="adv-card move" v-for="(item, index) in advList" :key="item.title" :style="{ transitionDelay: index * 0.1 + 's' }">
            <img class="adv-icon" :src="item.icon" alt="" />
            <div class="adv-title">{{ item.title }}</div>
            <div class="adv-desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 工作原理 -->
    <div class="section-flow">
      <div class="flow-main">
        <div class="section-title move">工作原理</div>
        <div class="section-sub move delay-100">极致简单，安全访问</div>
        <div class="flow-grid">
          <template v-for="(item, index) in flowList">
            <div class="flow-card move" :key="item.title" :style="{ transitionDelay: index * 0.1 + 's' }">
              <div class="flow-top">
                <img :src="item.img" alt="" />
              </div>
              <div class="flow-title">{{ item.title }}</div>
              <div class="flow-desc">{{ item.desc }}</div>
            </div>
            <div v-if="index < flowList.length - 1" class="flow-arrow" :key="'arrow-' + index">
              <svg width="30" height="30" viewBox="0 0 30 30" fill="none">
                <path d="M8 8l6 7-6 7" stroke="#3772ff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M16 8l6 7-6 7" stroke="#3772ff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </template>
        </div>
      </div>
    </div>

    <!-- 应用场景 -->
    <div class="section-scene">
      <div class="scene-main">
        <div class="section-title move">应用场景</div>
        <div class="scene-grid">
          <div class="scene-card move" v-for="(item, index) in sceneList" :key="item.title" :style="{ transitionDelay: index * 0.1 + 's' }">
            <div class="scene-img-wrap">
              <img :src="item.img" alt="" />
            </div>
            <div class="scene-title">{{ item.title }}</div>
            <div class="scene-desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部 CTA -->
    <div class="section-cta">
      <img class="cta-overlay" :src="ctaOverlay" alt="" />
      <div class="cta-main">
        <div class="cta-title">立即开始你的内网穿透体验</div>
        <div class="cta-sub">无需公网IP，无需复杂配置，让内网服务安全的被访问</div>
        <div class="btn-primary cta-btn" @click="goDownload">免费体验</div>
      </div>
    </div>

    <Foot></Foot>
  </div>
</template>

<script>
import Foot from '@/components/Foot.vue'

export default {
  name: 'IntranetPenetration',
  components: {
    Foot,
  },
  data: function () {
    return {
      featFast: require('@/assets/nat/feat_fast.png'),
      featSafe: require('@/assets/nat/feat_safe.png'),
      featStable: require('@/assets/nat/feat_stable.png'),
      bannerNat: require('@/assets/nat/banner_nat.webp'),
      ctaOverlay: require('@/assets/introduce/cta_bg.png'),
      advList: [
        {
          icon: require('@/assets/nat/adv_easy.png'),
          title: '简单易用',
          desc: '极简设置与辅助发现服务，轻松完成穿透',
        },
        {
          icon: require('@/assets/nat/adv_safe.png'),
          title: '安全可控',
          desc: '自定义访问规则、白名单、认证等多维度访问控制',
        },
        {
          icon: require('@/assets/nat/adv_stable.png'),
          title: '稳定可靠',
          desc: '基于公网服务器转发，访问稳定，持续在线',
        },
        {
          icon: require('@/assets/nat/adv_scale.png'),
          title: '灵活拓展',
          desc: '支持多线BGP、灵活带宽配置',
        },
      ],
      flowList: [
        {
          img: require('@/assets/nat/flow1.png'),
          title: '绑定设备',
          desc: '登录节点小宝账号即可绑定您的设备',
        },
        {
          img: require('@/assets/nat/flow2.png'),
          title: '创建穿透',
          desc: '配置内网服务地址，端口及其访问域名',
        },
        {
          img: require('@/assets/nat/flow3.png'),
          title: '访问服务',
          desc: '用户在互联网访问域名即可访问目标服务',
        },
      ],
      sceneList: [
        {
          img: require('@/assets/nat/scene1.webp'),
          title: '个人网站&博客',
          desc: '将个人站点、博客发布到互联网，分享您的内容',
        },
        {
          img: require('@/assets/nat/scene2.webp'),
          title: '企业办公系统',
          desc: '发布OA/ERP/CRM等系统，随时随地高效办公',
        },
        {
          img: require('@/assets/nat/scene3.webp'),
          title: '中继服务',
          desc: '提供中继公网环境，用于开发调试',
        },
        {
          img: require('@/assets/nat/scene4.webp'),
          title: '开发测试环境',
          desc: '分享测试站点给团队成员，提升协作效率',
        },
      ],
    }
  },
  methods: {
    goDownload: function () {
      if (this.$route.path !== '/download') {
        this.$router.push('/download')
      }
    },
    goDoc: function () {
      window.open('https://iepose.com/helpcenter_v3/')
    },
    // 滚动检查：进入视口的 .move 元素加 move-active，触发入场动画（同首页模式）
    checkInView: function (animatedElements) {
      const windowHeight =
        window.innerHeight || document.documentElement.clientHeight
      animatedElements.forEach((element) => {
        const elementTop = element.getBoundingClientRect().top
        const elementBottom = element.getBoundingClientRect().bottom
        const isInView = elementTop < windowHeight - 100 && elementBottom > 0
        if (isInView) {
          element.classList.add('move-active')
        }
      })
    },
  },
  mounted: function () {
    const animatedElements = document.querySelectorAll('.move')
    // 首屏元素立即检查一次（页面刚加载时尚未触发 scroll，避免首屏内容空白）
    this.$nextTick(() => {
      this.checkInView(animatedElements)
    })
    window.addEventListener('scroll', () => {
      this.checkInView(animatedElements)
    })
  },
}
</script>

<style scoped lang="less">
.intranet-penetration {
  width: 100%;

  .section-title {
    font-size: 40px;
    font-weight: 700;
    color: #1d1f24;
    text-align: center;
  }

  .section-sub {
    margin-top: 12px;
    font-size: 24px;
    line-height: 36px;
    color: #777e90;
    text-align: center;
  }

  .btn-primary {
    width: 160px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    color: #ffffff;
    font-size: 18px;
    border-radius: 8px;
    background: #3772ff;
    cursor: pointer;
  }

  .btn-primary:hover {
    opacity: 0.9;
  }

  /* ---------- 首屏 ---------- */
  .section-banner {
    padding-top: 122px;
    padding-bottom: 70px;
    // 横向渐变：左浅蓝 → 右淡蓝
    background: linear-gradient(90deg, #eaeeff 0%, #deebff 50%, #d9e7ff 100%);

    .banner-main {
      width: 1280px;
      margin: 0 auto;
      position: relative;
    }

    // 首屏右侧插画：600x360，右缘与内容区对齐
    .banner-pic {
      position: absolute;
      right: 0;
      top: -15px;
      width: 600px;
      height: 360px;
    }

    .banner-left {
      width: 580px;
      min-height: 328px;
    }

    .banner-title {
      width: fit-content;
      font-size: 64px;
      font-weight: 700;
      line-height: 72px;
      background: linear-gradient(
        90deg,
        #3772ff 0%,
        #aa56ff 35%,
        #ff6838 70%,
        #ff9924 100%
      );
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    .banner-subtitle {
      margin-top: 13px;
      font-size: 44px;
      font-weight: 700;
      line-height: 66px;
      color: #1d1f24;
    }

    .banner-desc {
      margin-top: 9px;
      width: 521px;
      font-size: 20px;
      line-height: 29px;
      color: #777e90;
    }

    .banner-btns {
      display: flex;
      margin-top: 33px;
    }

    .btn-ghost {
      margin-left: 16px;
      width: 160px;
      height: 48px;
      line-height: 46px;
      text-align: center;
      font-size: 18px;
      color: #3772ff;
      border: 1px solid #3772ff;
      border-radius: 8px;
      box-sizing: border-box;
      cursor: pointer;
    }

    .btn-ghost:hover {
      background: rgba(55, 114, 255, 0.08);
    }

    .banner-features {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 80px;
      height: 120px;
      padding: 0 67px;
      background: rgba(255, 255, 255, 0.4);
      border: 1px solid rgba(255, 255, 255, 0.5);
      border-radius: 20px;
      box-sizing: border-box;
      // 毛玻璃悬浮条：半透明白 + 背景模糊
      -webkit-backdrop-filter: blur(10px);
      backdrop-filter: blur(10px);
      box-shadow: 0 8px 24px rgba(23, 33, 94, 0.06);
    }

    .feature-item {
      display: flex;
      align-items: center;

      .feature-icon {
        width: 60px;
        height: 60px;
      }

      .feature-text {
        margin-left: 12px;

        .feature-title {
          font-size: 24px;
          font-weight: 700;
          line-height: 36px;
          color: #1d1f24;
        }

        .feature-sub {
          margin-top: 2px;
          font-size: 16px;
          line-height: 24px;
          color: #777e90;
        }
      }
    }
  }

  /* ---------- 为什么选择 ---------- */
  .section-adv {
    padding-top: 60px;
    padding-bottom: 82px;
    background: #ffffff;
    box-sizing: border-box;

    .adv-main {
      width: 1280px;
      margin: 0 auto;
    }

    .adv-grid {
      display: flex;
      justify-content: space-between;
      margin-top: 50px;
    }

    .adv-card {
      width: 302px;
      min-height: 220px;
      padding: 33px 24px 0;
      background: #f7f9fe;
      border-radius: 16px;
      box-sizing: border-box;

      .adv-icon {
        width: 48px;
        height: 48px;
        display: block;
      }

      .adv-title {
        margin-top: 24px;
        font-size: 24px;
        font-weight: 700;
        line-height: 36px;
        color: #1d1f24;
      }

      .adv-desc {
        margin-top: 10px;
        font-size: 14px;
        line-height: 21px;
        color: #777e90;
      }
    }
  }

  /* ---------- 工作原理 ---------- */
  .section-flow {
    padding-top: 60px;
    padding-bottom: 82px;
    background: #f7f9fe;
    box-sizing: border-box;

    .flow-main {
      width: 1280px;
      margin: 0 auto;
    }

    .flow-grid {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 50px;
    }

    .flow-card {
      width: 302px;
      padding: 30px 30px 0;
      // 卡片固定 300 高，文案行数不同也能等高
      min-height: 300px;
      background: #ffffff;
      border-radius: 20px;
      box-shadow: 0 4px 30px 0 rgba(55, 114, 255, 0.05);
      box-sizing: border-box;

      .flow-top {
        height: 140px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;

        img {
          width: 160px;
          height: 140px;
          object-fit: contain;
        }
      }

      .flow-title {
        margin-top: 20px;
        font-size: 24px;
        font-weight: 700;
        line-height: 34px;
        color: #1d1f24;
        text-align: center;
      }

      .flow-desc {
        // 底部留白 14px：两行文案时内容 286，配合 min-height 300 全卡等高；40px 会把卡顶超
        margin: 10px auto 14px;
        font-size: 16px;
        line-height: 26px;
        color: #777e90;
        text-align: center;
      }
    }

    .flow-arrow {
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }
  }

  /* ---------- 应用场景 ---------- */
  .section-scene {
    padding-top: 60px;
    padding-bottom: 82px;
    background: #ffffff;
    box-sizing: border-box;

    .section-title {
      color: #1d1f24;
    }

    .scene-main {
      width: 1280px;
      margin: 0 auto;
    }

    .scene-grid {
      display: flex;
      justify-content: space-between;
      margin-top: 50px;
    }

    .scene-card {
      width: 302px;
      background: #ffffff;
      box-sizing: border-box;

      .scene-img-wrap {
        height: 180px;
        border-radius: 16px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          }
      }

      .scene-title {
        margin-top: 19px;
        // 文本左右 12px
        padding: 0 12px;
        font-size: 24px;
        font-weight: 700;
        line-height: 36px;
        color: #1d1f24;
      }

      .scene-desc {
        margin-top: 13px;
        // 文本左右 12px
        padding: 0 12px;
        font-size: 14px;
        line-height: 21px;
        color: #777e90;
      }
    }
  }

  /* ---------- 底部 CTA ---------- */
  .section-cta {
    position: relative;
    padding-top: 67px;
    padding-bottom: 60px;
    background: #3772ff;
    overflow: hidden;
    box-sizing: border-box;

    .cta-overlay {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      mix-blend-mode: overlay;
      opacity: 0.6;
      pointer-events: none;
    }

    .cta-main {
      position: relative;
      width: 1280px;
      margin: 0 auto;
      text-align: center;
    }

    .cta-title {
      font-size: 40px;
      font-weight: 700;
      line-height: 60px;
      color: #ffffff;
    }

    .cta-sub {
      margin-top: 12px;
      font-size: 18px;
      color: #ffffff;
    }

    .cta-btn {
      margin: 26px auto 0;
      width: 168px;
      height: 48px;
      line-height: 48px;
      font-size: 19px;
      background: #ffffff;
      color: #3772ff;
    }
  }

  /* ---------- 滚动入场动画（同首页模式） ---------- */
  .move {
    opacity: 0;
    transform: translateY(50px);
    transition: opacity 0.8s ease-out, transform 0.8s ease-out;
  }
  .move-active {
    opacity: 1;
    transform: translateY(0);
  }
  /* 为不同元素设置不同的延迟，创建层次感 */
  .delay-100 {
    transition-delay: 0.1s;
  }
  .delay-200 {
    transition-delay: 0.2s;
  }
  .delay-300 {
    transition-delay: 0.3s;
  }
}
</style>
